<template>
  <!-- 下载中心-->
  <i
    class="download_center"
    :class="isStore ? 'store_download_center' : ''"
    v-if="showDown"
    :style="{ top: top }"
    @click="go_download"
  >
    <span v-if="downloadNum" class="download_num"></span>
    <span v-if="isStore" class="text">下载中心</span>
  </i>
</template>

<script>
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'

export default {
  name: 'DownloadCenterButton',
  props: {
    showDown: [String, Number, Boolean],
    downloadNum: [String, Number],
    top: {
      type: [String, Number],
      default: '3.2rem',
    },
    type: {
      type: String,
      default: 'all',
    },
    downloadType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {}
  },
  computed: {
    // * 当前是否门店系统下的模块
    isStore() {
      return StoreController.isStore(this)
    },
  },
  methods: {
    go_download() {
      // * 跳转到下载中心
      let zbid = this.isStore ? StoreController.zbId() : window.zbvd.zbid
      let path =
        this.type === 'all'
          ? '/agent/downloadCenter'
          : '/agent/landbill/downloadCenter'
      if (this.isStore) {
        path = '/store/downloadCenter'
      }
      // 核销记录的商品tab，点击下载中心
      if (this.downloadType && this.downloadType === 'goodsVerification') {
        path = '/agent/landbill/downloadCenter?from=goodsVerification'
      }
      if (this.downloadType && this.downloadType === 'couponVerification') {
        path = '/agent/downloadCenter?from=couponVerification'
      }
      this.$router.push({
        path,
        query: {
          zbid,
          tpid: window.zbvd.tpid,
          userid: this.$route.query.userid,
          isStore: this.isStore,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.download_center {
  position: relative;
  width: 30px;
  height: 98px;
  background: url('~@/assets/images/agent/downagent.png');
  background-size: 100% 100%;
  cursor: pointer;
  position: fixed;
  top: 332px;
  right: 0;
  z-index: 5;
  &.store_download_center {
    border-radius: 0.13rem 0 0 0.13rem;
    background: var(--primary-plain-background-linear-gradient);
    color: #fff;
    writing-mode: vertical-lr;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 0.05rem;
    font-size: 0.13rem;
    .text {
      font-style: normal;
    }
  }
  .download_num {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: -6px;
    top: 12px;
    width: 12px;
    height: 12px;
    background: #ff4444;
    border-radius: 50%;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}
</style>
